import React, { useEffect, useState } from "react";
import { ModalTitle, ReceiveStableCoinWrapper, Error, Container, QrCodeContainer, FooterText } from "./styles";
import FormMessageBanner from "../../../../components/common/FormMessageBanner";
import { ReactComponent as AlertIcon } from '../../../../assets/icons/alert-circle.svg'
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import QrCode from "./QrCode";
import CustomSelect from "../../../../components/common/CustomSelect";
import { useGetStableCoinWalletAddress, useStableCoinNetworks } from "../../../../app/queries/stableCoins";
import { useAppSelector } from "../../../../app/hooks";
import Loader from "../../../../components/common/Loader";

type ReceiveStableCoinsType = {
    network?: string;
}

export default function ReceiveStableCoin() {

    const { currencyCode } = useParams<{ currencyCode: string }>();
    const capitalizedCurrencyCode = currencyCode?.toUpperCase();

    const { businessId } = useAppSelector((state) => state?.users)
    const { keys } = useAppSelector((state) => state.settings);
    const publicKey = keys?.data?.publicKey;

    const { data: stableCoinNetworksList, isLoading: isStableCoinNetworksListLoading } = useStableCoinNetworks({ currency: capitalizedCurrencyCode, businessId: businessId });

    const { data: stableCoinWalletAddress, isLoading: isStableCoinWalletAddressLoading } = useGetStableCoinWalletAddress({ network: capitalizedCurrencyCode, businessId: businessId, token: publicKey });

    const { control, formState: { errors }, watch, reset } = useForm<ReceiveStableCoinsType>();
    const network = watch("network");

    const [addressValue, setAddressValue] = useState<string | null>(null);

    useEffect(() => {
        if (stableCoinNetworksList?.length) {
            reset({ network: stableCoinNetworksList[0].value });
        }
    }, [stableCoinNetworksList, reset]);

    useEffect(() => {
        if (stableCoinWalletAddress && network) {
            const addressValue = stableCoinWalletAddress?.find((item: any) => item.network === network);
            setAddressValue(addressValue?.address);
        }
    }, [stableCoinWalletAddress, network])

    return (
        <ReceiveStableCoinWrapper>
            <Loader isLoading={isStableCoinNetworksListLoading || isStableCoinWalletAddressLoading} />
            <ModalTitle>
                Top up your {capitalizedCurrencyCode} wallet
            </ModalTitle>

            <FormMessageBanner
                title="Verify your address and network"
                body="Klasha is not liable for incorrect address or network errors. Always double-check before making payment."
                icon={<AlertIcon />}
            />

            <Container>
                <div>
                    <Controller
                        name="network"
                        control={control}
                        rules={{ required: "Network is required" }}
                        render={({ field }) => {
                            return (
                                <CustomSelect
                                    {...field}
                                    $width="100%"
                                    lightBorder
                                    placeholder="Network"
                                    options={stableCoinNetworksList}
                                />
                            )
                        }}
                    />
                    {<Error>{errors.network?.message}</Error>}
                </div>

                <QrCodeContainer>
                    <QrCode value={addressValue} />
                </QrCodeContainer>

                <FooterText>
                    Use the <span>{network}</span> network when sending {capitalizedCurrencyCode} to this address. Your deposit will show up in your USDC wallet in just a few minutes.
                </FooterText>

            </Container>
        </ReceiveStableCoinWrapper>
    )
}